<nb-card>
  <nb-card-header class="dialog-header">
    <span>
      @if (!displayRadio) {
        {{ "Emission factors" | translate }} {{ energyTypeName }}
      }
      @if (displayRadio) {
        {{ scenarioName }}
      }
    </span>
    <span class="close-button" (click)="close()">
      <fa-icon icon="xmark"></fa-icon>
    </span>
  </nb-card-header>
  <nb-card-body>
    @if (!displayRadio) {
      <div class="first">
        {{ "First download an existing repository" | translate }}
      </div>
    }
    @if (displayRadio) {
      <div>{{ "Choose the emission factor referential for" | translate }} {{ sitesLabel }}</div>
    }
    @if (displayRadio) {
      <nb-radio-group name="initiativeScenarioFilter"
        class="filters-container"
        [(ngModel)]="providerId"
        >
        @for (provider of providerList; track provider) {
          <nb-radio [value]="provider.id">
            {{ provider.name }}
            &nbsp;&nbsp;
            <span class="based">{{ getBasedLabel(provider.based) | translate }}</span>
            &nbsp;&nbsp;
            <button nbButton ghost status="primary" (click)="openProvider(provider.id)">
              <i class="fa-light fa-eye"></i>
            </button>
          </nb-radio>
        }
      </nb-radio-group>
    } @else {
      <ul>
        @for (provider of providerList; track provider) {
          <li>
            {{ provider.name }}
            &nbsp;&nbsp;
            <span class="based">{{ getBasedLabel(provider.based) | translate }}</span>
            &nbsp;&nbsp;
            <button nbButton ghost status="primary" (click)="openProvider(provider.id)">
              <i class="fa-light fa-eye"></i>
            </button>
            @if (provider.based === 'MARKET') {
              <button
                nbButton ghost status="primary"
                (click)="openDeleteConfirmationDialog(provider.id, provider.name)"
                >
                <fa-icon icon="trash"></fa-icon>
              </button>
            }
          </li>
        }
      </ul>
    }

    @if (!displayRadio) {
      <div>
        ...{{ "Then you can change the values and select it below" | translate }}
      </div>
      <div class="file-input">
        <label class="custom-file-input-label" [class.disabled]="loading || readOnly">
          <span>{{ 'Select a file' | translate }}</span>
          <input nbInput type="file" (change)="onFileChange($event)" [disabled]="loading || readOnly" />
        </label>
      </div>
    }
  </nb-card-body>
  <nb-card-footer>
    <button (click)="validate()" class="ok-button">{{ "ok" | translate }}</button>
  </nb-card-footer>
</nb-card>

